// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  z-index: 9999;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.done-loading {
  display: none;
  z-index: 9999;
}

.still-loading {
  z-index: 9999;
}

.loading-bar-container {
  border: 2px solid #fff;
  padding: 2px;
  height: 11px;
  width: 24rem;
  background: #000000;
}

.loading-bar {
  height: 100%;
  background: white;
}

.landing-contain {
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.main-bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bar-container {
  border: 2px solid #fff;
  padding: 2px;
  height: 11px;
  margin-top: 40px;
  width: 27rem;
}

@media (min-width: 900px) {
  .page-img {
    width: 85%;
    height: 85%;
  }
}

@media (max-width: 900px) {
  .page-img {
    width: 75%;
    height: 75%;
  }
  .bar-container {
    width: 19rem;
    margin-left: 5%;
  }
}
@media (max-width: 550px) {
  .page-img {
    width: 80%;
    height: 80%;
  }
  .bar-container {
    width: 17rem;
    height: 11px;
    margin-left: 2%;
  }
}
@media (max-width: 400px) {
  .page-img {
    width: 80%;
    height: 80%;
  }
  
  .bar-container {
    padding: 2px;
    height: 11px;
    width: 16rem;
    background: #000000;
    margin-left: 2%;
  }
}
@media (max-width: 350px) {
  .page-img {
    width: 75%;
    height: 75%;
  }
  
  .bar-container {
    padding: 2px;
    height: 11px;
    width: 14rem;
    background: #000000;
    margin-left: 2%;
  }
}
@media (max-width: 270px) {
  .page-img {
    width: 75%;
    height: 75%;
  }
  
  .bar-container {
    padding: 2px;
    height: 11px;
    width: 12rem;
    background: #000000;
    margin-left: 2%;
  }
}




`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/ui/Loading/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".loading {\n  z-index: 9999;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.done-loading {\n  display: none;\n  z-index: 9999;\n}\n\n.still-loading {\n  z-index: 9999;\n}\n\n.loading-bar-container {\n  border: 2px solid #fff;\n  padding: 2px;\n  height: 11px;\n  width: 24rem;\n  background: #000000;\n}\n\n.loading-bar {\n  height: 100%;\n  background: white;\n}\n\n.landing-contain {\n  height: 100%; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n}\n\n.main-bar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.bar-container {\n  border: 2px solid #fff;\n  padding: 2px;\n  height: 11px;\n  margin-top: 40px;\n  width: 27rem;\n}\n\n@media (min-width: 900px) {\n  .page-img {\n    width: 85%;\n    height: 85%;\n  }\n}\n\n@media (max-width: 900px) {\n  .page-img {\n    width: 75%;\n    height: 75%;\n  }\n  .bar-container {\n    width: 19rem;\n    margin-left: 5%;\n  }\n}\n@media (max-width: 550px) {\n  .page-img {\n    width: 80%;\n    height: 80%;\n  }\n  .bar-container {\n    width: 17rem;\n    height: 11px;\n    margin-left: 2%;\n  }\n}\n@media (max-width: 400px) {\n  .page-img {\n    width: 80%;\n    height: 80%;\n  }\n  \n  .bar-container {\n    padding: 2px;\n    height: 11px;\n    width: 16rem;\n    background: #000000;\n    margin-left: 2%;\n  }\n}\n@media (max-width: 350px) {\n  .page-img {\n    width: 75%;\n    height: 75%;\n  }\n  \n  .bar-container {\n    padding: 2px;\n    height: 11px;\n    width: 14rem;\n    background: #000000;\n    margin-left: 2%;\n  }\n}\n@media (max-width: 270px) {\n  .page-img {\n    width: 75%;\n    height: 75%;\n  }\n  \n  .bar-container {\n    padding: 2px;\n    height: 11px;\n    width: 12rem;\n    background: #000000;\n    margin-left: 2%;\n  }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
